<template>
  <div class="main-style">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="main-tap">
      <el-tab-pane label="我的任务" name="/main/myTask">
      </el-tab-pane>
      <el-tab-pane label="我的项目" name="/main/myProject">
      </el-tab-pane>
    </el-tabs>
    <router-view ></router-view>

    <div v-if="activeName === '/main/myTask'" class="quick-visible">
      <el-checkbox style="margin-right: 20px;" v-model="checked" @change="change">仅查看我执行的</el-checkbox>
      <div class="btn-active" @click="openQuickVisible('quickVisible')">
        <i class="iconfont iconicon_develop" :class="{'open': quickVisible}"></i>
        <span>快速访问</span>
      </div>
    </div>
    <div v-if="activeName === '/main/myProject'" class="quick-visible" >
      <el-input v-model="state.keyword" placeholder="请搜索项目名称" prefix-icon="icon iconfont iconicon_search1" style="margin-right: 27px;width: 360px;" clearable></el-input>
      <div class="btn-active" @click="openQuickVisible('newsVisible')">
        <i class="iconfont iconicon_develop" :class="{'open': newsVisible}"></i>
        <span>项目动态</span>
      </div>
    </div>
    <ProjectNewsDialog v-model="newsVisible"></ProjectNewsDialog>
    <QuickDialog v-model="quickVisible"></QuickDialog>
  </div>
</template>

<script>
import QuickDialog from './myTask/quickDialog'
import ProjectNewsDialog from './myProject/starProject/projectNewsDialog.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    QuickDialog,
    ProjectNewsDialog
  },
  data() {
    return {
      activeName: '/main/myTask',
      quickVisible: false,
      newsVisible: false,
    }
  },
  watch: {
    '$route.path': {
      handler() {
        if(this.$route.path.indexOf('/main/myProject') > -1) {
          this.activeName = '/main/myProject'
        } else {
          this.activeName = '/main/myTask'
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('task/task', ['isOnlyMyExecutor']),
    ...mapState('home/home', {
      state: state => state
    }),
    checked: {
      get() {
        return this.isOnlyMyExecutor
      },
      set(val) {
        this.change(val)
      }
    }
  },
  methods: {
    ...mapActions('task/task', ['setIsOnlyMyExecutor']),
    handleClick(val) {
      this.$router.replace(val.name)
      this.quickVisible = false
      this.newsVisible = false
    },
    openQuickVisible(data) {
      this[data] = !this[data]
    },
    change(fl) {
      this.setIsOnlyMyExecutor(fl)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.main-style {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .quick-visible {
    position: absolute;
    right: 24px;
    top: 0px;
    z-index: 2;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 54px;
    @include fontColorOpacity(.6);
    i {
      font-size: 14px;
      margin-right: 9px;
      &.open {
        transform: rotate(180deg);
      }
    }
    /deep/ {
      .el-checkbox {
        display: flex;
        align-items: center;
        .el-checkbox__input {
          line-height: 1.2;
          display: flex;
          align-items: center;
        }
        .el-checkbox__label {
          @include fontColorOpacity(.6);
        }
      }
      .el-checkbox__input.is-checked .el-checkbox__inner::after {
        top: 1px;
      }
    }
  }
  /deep/ {
    .el-tabs__item {
      font-size: 14px;
    }
    .main-tap >{
      .el-tabs__header {
        padding: 0 32px;
        box-shadow: 0px 2px 8px 0px rgba(13,31,60,0.16);
        position: relative;
        z-index: 1;
      }
    }
    .main-tap {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      .el-tabs__content,.el-tab-pane{
        display: none;
      }
    }
    .project-news-dialog, .quick-dialog {
      position: absolute;
      // top: 48px;
    }
  }
}
</style>
